import Cookie from 'js-cookie';

function getToken() {
    return Cookie.get(process.env.REACT_APP_TOKEN) || null;
}
  
export const clearStorage = async () => {
    localStorage.clear();
    sessionStorage.clear();
    if (window.location.origin.indexOf('localhost') !== -1) {
      Cookie.remove(process.env.REACT_APP_TOKEN);
    }
  
    Cookie.remove(process.env.REACT_APP_TOKEN, {
      domain:
        window.location.origin.indexOf('localhost') !== -1
          ? `${window.location.hostname}`
          : `${process.env.REACT_APP_DOMAIN}`,
    });
    // eslint-disable-next-line array-callback-return
    Object.keys(Cookie.get()).map((item) => {
      if (window.location.origin.indexOf('localhost') !== -1) {
        Cookie.remove(item);
      }
      Cookie.remove(item, {
        domain:
          window.location.origin.indexOf('localhost') !== -1
            ? `${window.location.hostname}`
            : `${process.env.REACT_APP_DOMAIN}`,
      });
    });
};

export {getToken};
